import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { formatCurrency } from '../../../utils/formatters';

interface ProductoSearchProps {
  open: boolean;
  onClose: () => void;
  onSearch: (searchTerm: string) => void;
  onSelect: (producto: any) => void;
  productos: any[];
  searchTerm: string;
  onSearchTermChange: (value: string) => void;
  loading: boolean;
}

const ProductoSearch: React.FC<ProductoSearchProps> = ({
  open,
  onClose,
  onSearch,
  onSelect,
  productos,
  searchTerm,
  onSearchTermChange,
  loading,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Buscar Producto</DialogTitle>
      <DialogContent>
        <Box display="flex" gap={1} mb={2}>
          <TextField
            fullWidth
            label="Buscar producto"
            value={searchTerm}
            onChange={(e) => onSearchTermChange(e.target.value)}
          />
          <Button
            variant="contained"
            onClick={() => onSearch(searchTerm)}
            disabled={loading}
          >
            Buscar
          </Button>
        </Box>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Código</TableCell>
                <TableCell>Descripción</TableCell>
                <TableCell align="right">Precio</TableCell>
                <TableCell align="center">Acciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {productos.map((producto) => {
                const precio = Number(producto.precioVenta ?? producto.precio ?? producto.costo ?? producto.precioLista ?? producto.precioUnitario ?? 0);
                return (
                  <TableRow key={producto.codigo}>
                    <TableCell>{producto.codigo}</TableCell>
                    <TableCell>{producto.descripcion}</TableCell>
                    <TableCell align="right">{formatCurrency(precio)}</TableCell>
                    <TableCell align="center">
                      <Button
                        variant="outlined"
                        onClick={() => onSelect(producto)}
                      >
                        Seleccionar
                      </Button>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProductoSearch;